import { OrganizationIcon } from '@hcs/design-system';
import { AppSlugs } from '@hcs/types';
import { AppConfig } from '@hcs/types';

export const APP_CONFIG_CLIENT_ADMIN: AppConfig = {
  name: 'Client Admin',
  applicationKey: 'internal-client-admin',
  type: 'internal',
  appSlugForEngagement: AppSlugs.ClientAdmin,
  rootPath: '/client-admin',
  Icon: OrganizationIcon,
  descriptionLong:
    'Manage Org Users, Subscriptions, Feature Flag Access, and Preferences',
  descriptionShort: 'Organization & User Management',
};

export const VIEW_PATHS_CLIENT_ADMIN = {
  ACCOUNT_SYNC: 'salesforce-sync',
  CONTRACT_SYNC: 'salesforce-sync/:contractNumber',
  // Orgs
  ORGANIZATIONS: 'organizations',
  ORG: 'organizations/:orgId',
  ORG_USERS: 'organizations/:orgId/users',
  ORG_API_RATE_LIMITS: 'organizations/:orgId/api-rate-limits',
  ORG_APPLICATIONS: 'organizations/:orgId/applications',
  ORG_SSO: 'organizations/:orgId/sso',
  ORG_BILLING: 'organizations/:orgId/billing',
  ORG_USAGE: 'organizations/:orgId/usage',
  ORG_ENTITLEMENTS: 'organizations/:orgId/entitlements',
  ORG_ROLES: 'organizations/:orgId/roles',
  ORG_DEVFLAGS: 'organizations/:orgId/devflags',
  ORG_CAPABILITIES: 'organizations/:orgId/capabilities',

  // Users
  USERS: 'users',
  USER: 'users/:userId',
  USER_DETAILS: 'users/:userId/details',
  USER_API_AUTH_KEYS: 'users/:userId/api-auth-keys',
  USER_ACCESS: 'users/:userId/access',
  USER_LOGIN_AS_USER: 'users/:userId/login-as-user',

  // Sponsors
  SPONSORS: 'sponsors',
  SPONSOR: 'sponsors/:sponsorId',
  SPONSOR_USERS: 'sponsors/:sponsorId/users',
  SPONSOR_SSO: 'sponsors/:sponsorId/sso',
} as const;

export const DEFAULT_PATH_CLIENT_ADMIN_ORG = VIEW_PATHS_CLIENT_ADMIN.ORG_USERS;
